// extracted by mini-css-extract-plugin
export default {"mainContainer":"Documents_mainContainer__j+b4F"};